import { RangeDef } from "modules/common/components/Alarms/Form/components/Measurements/types/RangeType";
import { ThresholdDef } from "modules/common/components/Alarms/Form/components/Measurements/types/TresholdType";
import { StationType, ValueRange } from "modules/common/components/Alarms/types/AlarmsForm";
import { AlarmTypeEnum } from "services";

export interface AlarmFormMeasurement {
    measurementType: string;
    measurementUnit: string;
    min?: string;
    max?: string;
    amountName?: string;
    daysName?: string;
}

export enum MeasurementType {
    AirTemperature = "Temperatura zraka",
    Humidity = "Vlažnost zraka",
    WindSpeed = "Brzina vjetra",
    Rainfall = "Oborine",
    Pests = "Štetnici",
    Phenophase = "Fenofaza",
}

export interface Measurement {
    id: MeasurementType;
    type: AlarmTypeEnum;
    stationTypes: StationType[];
    measurementType: string;
    measurementUnit?: string;
    valueRange?: ValueRange<number>;
    amount?: number;
    lookbackDays?: number;
    cultureId?: number;
    phenophaseId?: number;
}

export const measurementTypesOptions: Measurement[] = [
    {
        id: MeasurementType.AirTemperature,
        type: AlarmTypeEnum.Regular,
        stationTypes: [StationType.Metos, StationType.Pinova],
        measurementType: "Temperatura zraka",
        measurementUnit: "°C",
        valueRange: {
            min: 0,
            max: 0,
        },
    },
    {
        id: MeasurementType.Humidity,
        type: AlarmTypeEnum.Regular,
        stationTypes: [StationType.Metos, StationType.Pinova],
        measurementType: "Vlažnost zraka",
        measurementUnit: "%",
        valueRange: {
            min: 0,
            max: 0,
        },
    },
    {
        id: MeasurementType.WindSpeed,
        type: AlarmTypeEnum.Regular,
        stationTypes: [StationType.Pinova],
        measurementType: "Brzina vjetra",
        measurementUnit: "m/s",
        valueRange: {
            min: 0,
            max: 0,
        },
    },
    {
        id: MeasurementType.Rainfall,
        type: AlarmTypeEnum.ForSpecificLoockbackDays,
        stationTypes: [StationType.Metos, StationType.Pinova],
        measurementType: "Oborine",
        measurementUnit: "mm",
        amount: 0,
        lookbackDays: 0,
    },
    {
        id: MeasurementType.Pests,
        type: AlarmTypeEnum.ForSpecificLoockbackDays,
        stationTypes: [StationType.Metos],
        measurementType: "Štetnici",
        measurementUnit: "kom",
        amount: 0,
        lookbackDays: 0,
    },
    {
        id: MeasurementType.Phenophase,
        type: AlarmTypeEnum.Phenophase,
        stationTypes: [StationType.Metos],
        measurementType: "Fenofaza",
        measurementUnit: "",
        cultureId: 0,
        phenophaseId: 0,
    },
];

export const rangeInputs: RangeDef[] = [
    {
        id: MeasurementType.AirTemperature,
        measurementType: "Temperatura zraka",
        measurementUnit: "°C",
        min: 0,
        max: 0,
    },
    {
        id: MeasurementType.Humidity,
        measurementType: "Vlažnost zraka",
        measurementUnit: "%",
        min: 0,
        max: 0,
    },
    {
        id: MeasurementType.WindSpeed,
        measurementType: "Brzina vjetra",
        measurementUnit: "m/s",
        min: 0,
        max: 0,
    },
];

export const thresholdInputs: ThresholdDef[] = [
    {
        id: MeasurementType.Rainfall,
        measurementType: "Oborine",
        measurementUnit: "mm",
        amount: 0,
        lookbackDays: 0,
    },
    {
        id: MeasurementType.Pests,
        measurementType: "Štetnici",
        measurementUnit: "kom",
        amount: 0,
        lookbackDays: 0,
    },
];
